// import { ResetPasswordForm } from "components/ResetPassword";

import { AccountLayout } from "../../layouts";

export const ResetPasswordPage = () => {
  return (
    // <AccountLayout contents={<ResetPasswordForm />} />
    <AccountLayout contents={'<ResetPasswordForm />'} />
  );
}
